<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>{{ "dialogs.inviteUser.title" | translate }}</h4></nb-card-header
    >
    <nb-card-body>
      <div class="form-group row">
        <label for="name" class="label col-sm-3 col-form-label">
          {{ "input.name.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="text"
            nbInput
            fullWidth
            id="name"
            formControlName="name"
            placeholder="{{ 'input.name.placeholderUser' | translate }}"
            [status]="showInputError('name') ? 'danger' : 'basic'"
          />
        </div>
      </div>
      <!--  -->
      <div class="form-group row">
        <label for="email" class="label col-sm-3 col-form-label">
          {{ "input.email.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="email"
            nbInput
            fullWidth
            id="email"
            pattern="^\S+@\S+\.\S+$"
            formControlName="email"
            placeholder="{{ 'input.email.placeholder' | translate }}"
            [status]="showInputError('email') ? 'danger' : 'basic'"
          />
        </div>
      </div>

      <nb-form-field>
        <label for="role" class="label col-sm-3 col-form-label role-label">
          {{ "input.role.label" | translate }}
          <nb-icon
            icon="info-outline"
            class="role-info"
            [nbTooltip]="
              ('dialogs.inviteUser.roleInfo.intro' | translate) +
              '\n\n' +
              ('dialogs.inviteUser.roleInfo.featureSets' | translate)
            "
            nbTooltipPlacement="top"
          ></nb-icon>
        </label>

        <nb-select
          formControlName="role"
          [status]="showInputError('role') ? 'danger' : 'basic'"
        >
          <nb-option
            *ngFor="let v of roles"
            [value]="v"
            [nbTooltip]="('input.role.tooltips.' + v) | translate"
            [nbTooltipDisabled]="!hasRoleTooltip(v)"
            nbTooltipPlacement="right"
            nbTooltipClass="role-tooltip"
            >{{ v }}</nb-option
          >
        </nb-select>

        <!-- No hint for super_admin: it's a platform role end customers never
             see, and there is deliberately no roleInfo entry for it. -->
        <p *ngIf="selectedRole && selectedRole !== 'super_admin'" class="role-hint">
          {{ roleHintKey(selectedRole) | translate }}
        </p>
      </nb-form-field>

      <nb-form-field *ngIf="showFeatureSetField">
        <label for="feature_set_id" class="label col-sm-3 col-form-label">
          {{ "dialogs.inviteUser.featureSet" | translate }}
        </label>

        <nb-select formControlName="feature_set_id">
          <nb-option [value]="null">{{ "dialogs.inviteUser.noFeatureSet" | translate }}</nb-option>
          <nb-option *ngFor="let fs of featureSets" [value]="fs.id">
            {{ getFeatureSetDisplayName(fs) }}
          </nb-option>
        </nb-select>
      </nb-form-field>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary">
        {{ "buttons.invite" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
